var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.loading,"absolute":"","opacity":0}},[_c('div',{staticClass:"overlay-content"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-1","size":"48"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }